import api from 'axios'
import { URL_BACK } from '../../variableProd'
/**
 * Servicio para autenticación y administración de Colaboradores
 * @module ServicioColaboradores
 */
const getData  = URL_BACK + '/historial/getDataOk.php'
const getDataError  = URL_BACK + '/historial/getDataError.php'
const getReporte  = URL_BACK + '/historial/getReporte.php'

/**
 * Funciones para autenticación y administración de usuarios.
 */

export default {
  /**
   * Colaboradores
   * @param {object} model - Modelo de Enviar datos para pagos totales
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */

  getData(model) {
  {
    return new Promise((resolve, reject) => {
      api
        .post(getData, model)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  },

  getDataError(model) {
  {
    return new Promise((resolve, reject) => {
      api
        .post(getDataError, model)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  },
  getReporte(model) {
  {
    return new Promise((resolve, reject) => {
      api
        .post(getReporte, model)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  },
  
}
